<form [formGroup]="dynamicListForm">
    <mat-form-field class="select-field" *ngIf="!showLoader" color="accent">
      <mat-select formControlName="select" [placeholder]="data.placeholder| translate" (selectionChange)="onSelectionChange()">
        <mat-option [value]="option" *ngFor="let option of dynamicList">{{ option[data.selectByProperty] }}</mat-option>
      </mat-select>
    </mat-form-field>
  <mat-progress-spinner *ngIf="showLoader" mode="indeterminate" [diameter]="20" color="accent"></mat-progress-spinner>
</form>
